var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLtAppLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 660 165",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.36 71.267h414.28v118.14h-414.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.988 68.193h56.186v55.372h-56.186z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 806.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.869 414.83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.44 73.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.871 54.987-15.402-31.587c-0.197-0.391-0.392-0.976-0.585-1.367-0.589-1.364-1.368-2.923-1.95-4.679-1.171 3.121-2.147 5.264-2.538 6.046l-15.793 31.587-12.674-54.987h8.581l5.654 25.544c0.389 1.949 0.779 3.511 0.779 5.264 0.586-1.559 1.171-3.121 1.95-4.679l13.844-28.664 13.844 28.079c0.782 1.756 1.561 3.511 1.953 5.264 0-0.582 0.193-1.168 0.193-1.753 0.195-1.755 0.391-2.732 0.391-3.317l5.849-25.738z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.45 99.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 7.216-2.729 13.844-7.998 18.913-5.264 5.07-11.892 7.802-19.105 7.802-7.41 0-14.043-2.732-19.307-7.802-5.07-5.069-7.801-11.697-7.801-18.913s2.731-13.844 7.801-18.72c5.072-5.069 11.897-7.801 19.307-7.801 7.213 0 14.038 2.732 19.105 7.801 5.269 4.876 7.998 11.504 7.998 18.72m-9.166 0c0-4.875-1.755-9.554-5.263-13.064-3.511-3.511-7.801-5.264-12.674-5.264-4.875 0-9.362 1.753-12.676 5.264-3.509 3.51-5.267 7.995-5.267 13.064s1.95 9.554 5.267 13.064c3.314 3.512 7.801 5.264 12.676 5.264 4.873 0 9.357-1.949 12.674-5.264 3.508-3.51 5.263-8.189 5.263-13.064"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(463.29 99.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 7.216-2.729 13.844-7.995 18.913-5.264 5.07-11.895 7.802-19.109 7.802-7.41 0-14.041-2.732-19.303-7.802-5.073-5.069-7.802-11.697-7.802-18.913s2.729-13.844 7.802-18.72c5.069-5.069 11.893-7.801 19.303-7.801 7.214 0 14.039 2.732 19.109 7.801 5.266 4.876 7.995 11.504 7.995 18.72m-9.166 0c0-4.875-1.755-9.554-5.264-13.064-3.51-3.511-7.8-5.264-12.674-5.264-4.875 0-9.362 1.753-12.675 5.264-3.509 3.51-5.264 7.995-5.264 13.064s1.949 9.554 5.264 13.064c3.313 3.512 7.995 5.264 12.675 5.264 4.874 0 9.361-1.949 12.674-5.264 3.315-3.51 5.264-8.189 5.264-13.064"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.02 99.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 7.216-2.729 13.844-7.998 18.913-5.261 5.07-11.892 7.802-19.105 7.802-7.41 0-14.043-2.732-19.304-7.802-5.072-5.069-7.801-11.697-7.801-18.913s2.729-13.844 7.801-18.72c5.069-5.069 11.894-7.801 19.304-7.801 7.213 0 14.038 2.732 19.105 7.801 5.269 4.876 7.998 11.504 7.998 18.72m-9.166 0c0-4.875-1.755-9.554-5.263-13.064-3.511-3.511-7.801-5.264-12.674-5.264-4.875 0-9.362 1.753-12.676 5.264-3.509 3.51-5.267 7.995-5.267 13.064s1.758 9.554 5.267 13.064c3.314 3.512 7.995 5.264 12.676 5.264 4.873 0 9.357-1.949 12.674-5.264 3.314-3.51 5.263-8.189 5.263-13.064"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.55 111.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 4.875-1.95 8.968-5.264 11.503-3.317 2.537-7.41 2.926-13.262 2.926h-12.285v-52.259h8.774v23.206h0.391l17.549-23.009h10.531l-18.135 23.592c7.604 0.976 11.701 5.852 11.701 14.041m-20.281-7.41h-1.168v14.041h1.168c7.216 0 10.918-1.171 10.918-7.41-0.192-5.656-3.311-6.631-10.918-6.631"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.35 111.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 4.875-1.949 8.968-5.264 11.503-3.313 2.537-7.409 2.926-13.261 2.926h-12.283v-52.259h8.775v23.206h0.388l17.549-23.009h10.531l-18.135 23.592c7.604 0.976 11.7 5.852 11.7 14.041m-20.475-7.41h-1.17v14.041h1.17c7.216 0 10.921-1.171 10.921-7.41 0-5.656-3.119-6.631-10.921-6.631"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528.81 126.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-8.969l-9.751-24.568c-0.976-2.732-1.756-4.875-2.143-6.825-0.783 2.338-1.562 4.678-2.341 7.019l-11.115 26.909-10.724-26.517-0.194-0.586c-0.392-1.17-1.171-3.511-2.341-6.825-0.782 2.535-1.559 4.872-2.341 7.019l-9.751 24.374h-8.966l20.276-54.987 11.897 29.051c0.779 1.954 1.364 3.903 2.144 6.241 0.585-1.95 1.367-3.9 2.143-6.043l12.092-29.249z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.82 132.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-12.491 11.797-23.775 22.453-35.998 33.996v-31.521h-10.241v54.16c12.371-11.703 23.891-22.607 36.414-34.456v32.058h9.825z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.5 153.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c5.035 11.634 9.739 22.501 14.486 33.468h9.662c-8.023-18.262-15.836-36.034-24.188-55.033-8.27 18.736-16.113 36.505-24.194 54.81h9.639c4.544-10.35 9.354-21.311 14.595-33.245"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.21 142.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-7.903h-24.848v51.827h8.584v-43.924z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m163.35 186.9h8.669v-52.167h-8.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.64 134.7h-8.235v52.188h8.235z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.93 162.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-28.193v-9.394h17.521c-0.9-2.232-2.23-4.296-3.997-6.065-3.594-3.594-7.986-5.387-12.976-5.387-4.987 0-9.58 1.793-12.974 5.387-3.593 3.593-5.389 8.183-5.389 13.372 0 5.19 1.999 9.779 5.389 13.373 3.394 3.591 8.184 5.386 12.974 5.386 4.99 0 9.58-1.992 12.976-5.386 1.145-1.216 2.118-2.583 2.923-4.036l7.139 5.872c-1.005 1.467-2.143 2.868-3.476 4.15-5.39 5.192-12.178 7.987-19.562 7.987-7.582 0-14.369-2.795-19.761-7.987-5.187-5.189-7.981-11.974-7.981-19.359 0-7.384 2.794-14.169 7.981-19.159 5.195-5.192 12.179-7.986 19.761-7.986 7.384 0 14.369 2.794 19.562 7.986 5.386 4.99 8.183 11.775 8.183 19.159 0 0.705-0.051 1.396-0.1 2.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(541.01 114.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.705 0 6.631 2.729 6.631 6.046 0 3.508-2.926 6.042-6.631 6.042-3.702 0-6.628-2.729-6.628-6.042 0-3.317 2.926-6.046 6.628-6.046m0 11.309c3.122 0 5.46-2.144 5.46-5.07s-2.534-5.069-5.46-5.069c-3.12 0-5.461 2.341-5.461 5.069-0.191 2.926 2.341 5.07 5.461 5.07m1.173-5.46c0.973 0 1.949 0.585 1.949 1.952 0 1.364-1.173 1.753-2.537 1.753h-3.12v-6.825h1.171v3.12h1.364l1.949-3.12h1.173zm-0.782 2.731c0.973 0 1.755 0 1.755-0.976 0-0.973-1.367-0.78-2.34-0.78h-1.17v1.756z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.493 540.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-7.798h10.921v-44.264h9.36v44.264h10.724v7.798z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.869 414.83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1390)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.19 72.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.083 0 0.083 0.082 0.163 0.082-0.08 0-0.08-0.082-0.163-0.082"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.48 78.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.903-2.124 2.695-4.164c0.083 0 0.083 0.083 0.166 0.083z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.576 115.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 9.065-2.615-6.941 6.862z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.91 93.019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.004-13.884 10.944 2.695z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.083 68.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.657 2.449-2.694 4.247z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.015 70.969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.163-0.083 0.245-0.163 0.408-0.163-0.163 0.08-0.325 0.163-0.408 0.163"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.753 68.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.696 6.613-2.124-4.244c0.163-0.083 0.245-0.166 0.408-0.166z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.07 94.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.225-6.126 0.816-2.203 2.124 8.982z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.234 97.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.041 7.596-0.899-2.696-1.225-4.655c0-0.245 0-0.57-0.082-0.816z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.323 122.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.309-1.878 1.715-3.594 6.451 6.042z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.29 117.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.878 3.757-7.758 1.961z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.638 112.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.268-12.251 2.697 9.395z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.47 95.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.737-15.026 8.904 15.351z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.487 75.706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.595-7.513 6.697 7.513z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.521 92.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.532-10.944 10.127-2.778z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.439 100.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.942 12.169-9.391-3.103z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.755 123.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.004-7.433h15.517z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.616 112.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.658-14.209 16.825 0.325z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.265 93.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.412-15.108h17.149z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.648 80.197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.329 14.946-16.741 0.245z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.57 97.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.25 14.129-7.92-13.967z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.265 98.736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.9 14.617h-17.475z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.361 115.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.715 3.511-3.919-3.266-2.449-2.94z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.848 78.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.88-5.797 1.795 3.674z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.01 97.592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.369 8.658-2.287-8.087z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.937 500.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.369 9.065-4.898 0.571z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtAppLogo);
export default __webpack_public_path__ + "static/media/lt_app_logo.18cdba2c4a8f4e1c079613de3467381e.svg";
export { ForwardRef as ReactComponent };